/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useState } from 'react'

import { EuiButtonEmpty, EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import TagBadge from '@modules/resources-shared-components/Tags/TagBadge'
import { stringifyTag } from '@modules/resources-shared-components/Tags/helpers'
import type { Tag } from '@modules/resources-shared-components/Tags/types'

type Props = {
  tags: Tag[]
  max?: number
}

const TagsDisplay = ({ tags, max = 5 }: Props) => {
  const [showAllTags, setShowAllTags] = useState(false)

  const tagsToShowKeys = showAllTags ? tags : tags.slice(0, max)

  return (
    <EuiFlexGroup gutterSize='s' alignItems='flexEnd' wrap={true}>
      {tagsToShowKeys.map((tag) => (
        <EuiFlexItem key={stringifyTag(tag)} grow={false} style={{ maxWidth: '300px' }}>
          <TagBadge tag={tag} hasCopyButton={true} />
        </EuiFlexItem>
      ))}

      {tags.length > max &&
        (showAllTags ? (
          <EuiButtonEmpty size='xs' onClick={() => setShowAllTags(false)}>
            <FormattedMessage id='resource.tags.showLess' defaultMessage='Show less' />
          </EuiButtonEmpty>
        ) : (
          <EuiButtonEmpty size='xs' onClick={() => setShowAllTags(true)}>
            <FormattedMessage id='resource.tags.showAll' defaultMessage='Show all tags' />
          </EuiButtonEmpty>
        ))}
    </EuiFlexGroup>
  )
}

export default TagsDisplay
